module.exports = __webpack_public_path__ + "img/icon-clock.6c54fe3e.svg";